export default __webpack_public_path__ + "static/media/whatsapp-color.27d3105f.svg";